import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {ModelManager, Constants} from '@adobe/aem-spa-page-model-manager';
import App from './App';
import './MappedComponents';
import aemReactPolyfill from '../../aem-react-polyfill';
import {store} from '@/store';
import NotificationContainer from '@/features/notifications/components/NotificationsContainer';
import {mapUnknownComponents} from '@/utils/aem-utils';
// Solve ModelManager issues on ie 11
aemReactPolyfill.init();
console.info('Allowed: [SRA: v.3.7]');

let searchResults = [].slice.call(document.querySelectorAll('.search-result-wrapper'));
if (searchResults && searchResults.length) {
  searchResults.forEach((appWrapper) => {
    const root = createRoot(appWrapper);

    function render(model) {
      mapUnknownComponents(model[Constants.ITEMS_PROP], model[Constants.ITEMS_ORDER_PROP]);
      root.render(
        <Provider store={store}>
          <App
            cqChildren={model[Constants.CHILDREN_PROP]}
            cqItems={model[Constants.ITEMS_PROP]}
            cqItemsOrder={model[Constants.ITEMS_ORDER_PROP]}
            cqPath={model[Constants.PATH_PROP]}
            appWrapper={appWrapper}
          />
          <NotificationContainer />
        </Provider>,
      );
    }

    ModelManager.initialize({path: process.env.REACT_APP_PAGE_MODEL_PATH}).then(render);
  });
}
